import { useState, useEffect, useLayoutEffect } from 'react'

export const useGetSize = (
  getSize: () => {
    width?: number
    height?: number
  }
) => {
  const [elementSize, setElementSize] = useState(getSize)

  useEffect(() => {
    const handleResize = () => {
      setElementSize(getSize())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [getSize]) // Empty array ensures that effect is only run on mount and unmount

  useLayoutEffect(() => {
    setElementSize(getSize())
  }, [getSize])

  return elementSize
}
